const initExpanders = () => {
    jQuery('.block\\3A inline-popups').inlinePopup({
        itemSelector: '.trigger',
        closeinnerelem: '',
        arrow: false,
        activeFirst: false,
    })
}
